import { createFileRoute, redirect } from '@tanstack/react-router'

import { DEFAULT_MASTRA_AGENT_ID } from '@/widgets/mastra-chat'

// Back-compat redirect: the chat is now agent-scoped (`/agents/$agentId/chat`), so the old
// agent-less URL forwards to the default ("General") agent.
export const Route = createFileRoute('/_app/agents/chat')({
  beforeLoad: () => {
    throw redirect({
      to: '/agents/$agentId/chat',
      params: { agentId: DEFAULT_MASTRA_AGENT_ID },
      replace: true,
    })
  },
})
